namespace Areas.Dialogs.EventFileUpload {
    "use strict";

    export class EventFileUploadDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("EventFileUpload", closeHandler, parameters, () => {
                var uploader = $("#fileUploaderControl").dxFileUploader("instance");
                let url: any = uploader.option("uploadUrl");

                url = updateQueryStringParameter(url, "recordId", parameters.eventId);
                console.log(url);
                uploader.option("uploadUrl", url);
            });
        }

        protected ok = (e: any) => {
            this.close(DialogResult.Ok, null);
        }
    }

    export function vendorSelected(e) {
        var uploader = $("#fileUploaderControl").dxFileUploader("instance");
        let url: any = uploader.option("uploadUrl");

        const vendorId = e.value;

        if (vendorId > 0) {
            uploader.option("disabled", false);
            url = updateQueryStringParameter(url, "vendorId", e.value);
            console.log(url);
            uploader.option("uploadUrl", url);
        }
    }

    export function vendorUserLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div><span class="collookupspanvendorUser">${itemData.vendorName}</span></div>`);
    }

}